import { buildOrganizedTourResourceProxyUrl } from "./buildOrganizedTourResourceProxyUrl";

/**
 * Hosts known to block cross-origin iframe PDF viewers (X-Frame-Options / CSP).
 * Same-origin proxy is required only for these.
 */
export const ORG_TOUR_PDF_PROXY_REQUIRED_HOST_SUFFIXES = [
  "natouronline.com",
  "lds.sabre.com",
  "sabre.com",
];

export function organizedTourPdfNeedsSameOriginProxy(resourceUrl) {
  const raw = String(resourceUrl || "").trim();
  if (!raw) return false;
  try {
    const host = new URL(raw).hostname.toLowerCase().replace(/\.$/, "");
    return ORG_TOUR_PDF_PROXY_REQUIRED_HOST_SUFFIXES.some((suffix) => {
      const base = String(suffix || "")
        .toLowerCase()
        .replace(/^\./, "");
      return Boolean(base) && (host === base || host.endsWith(`.${base}`));
    });
  } catch {
    return false;
  }
}

/**
 * iframe src for an organized-tour itinerary PDF.
 * Direct supplier URL by default; proxy only when the host blocks framing.
 */
export function resolveOrganizedTourPdfEmbedSrc(resourceUrl) {
  const direct = String(resourceUrl || "").trim();
  if (!direct || !/^https?:\/\//i.test(direct)) return null;
  if (/^https:\/\//i.test(direct) && organizedTourPdfNeedsSameOriginProxy(direct)) {
    return buildOrganizedTourResourceProxyUrl(direct);
  }
  return direct;
}
